import * as actionTypes from "redux/actionTypes/Index";
import { CnicVerificationInitialState } from "./InitialState";
import { IActionType } from "interfaces/Index";

const initialState = { ...CnicVerificationInitialState };
export default function cnicVerificationReducer(
  state = initialState,
  action: IActionType
) {
  switch (action.type) {
    case actionTypes.GET_CNIC_VERIFICATION_DATA_INIT: {
      return Object.assign({}, state, {
        isLoading: false,
        pagination: null,
        isCnicVerificationDataFetched: false,
        isCnicVerificationDataFetchedError: false,
        isError: false,
        error: null,
      });
    }
    case actionTypes.GET_CNIC_VERIFICATION_DATA_FAIL: {
      return Object.assign({}, state, {
        isLoading: false,
        pagination: null,
        isCnicVerified: false,
        cnicVerificationData: [],
        isCnicVerificationDataFetched: false,
        isCnicVerificationDataFetchedError: false,
        isError: true,
        error: action.error,
      });
    }

    case actionTypes.GET_CNIC_VERIFICATION_DATA_SUCCESS: {
      return Object.assign({}, state, {
        isLoading: false,
        isCnicVerificationDataFetched: true,
        isCnicVerificationDataFetchedError: false,
        isCnicVerified: false,
        isError: false,
        error: null,
        cnicVerificationData: (action.payload! as any).cnicVerificationData,
        pagination: (action.payload! as any).pagination,
      });
    }
    case actionTypes.VERIFY_CNIC_DATA_INIT: {
      return Object.assign({}, state, {
        isCnicVerified: false,
        isError: false,
        error: null,
      });
    }

    case actionTypes.VERIFY_CNIC_DATA_SUCCESS: {
      return Object.assign({}, state, {
        isCnicVerified: true,
        isError: false,
        error: null,
      });
    }

    case actionTypes.VERIFY_CNIC_DATA_FAIL: {
      return Object.assign({}, state, {
        isCnicVerified: false,
        isError: true,
        error: action.error,
      });
    }
    default:
      return state;
  }
}
